<template>
  <div id="page-rightpetition" class="d-flex">
    <MainBarMenu />
    <div class="header-top">
      <div class="container-fluid">
        <HeadingUser />
      </div>
    </div>
    <div class="layout-content container-fluid mt-5">
      <div class="page-rightpetition py-0">
        <div class="container">
          <p class="title-1 mb-0 mt-0">
            DERECHO DE PETICIÓN - DP{{ this.$route.params.id }}
          </p>
          <div class="row">
            <div class="col-12 col-md-6 col-lg-6 col-xl-6">
              <div
                class="
                  cont-rightpetition-text
                  d-flex
                  flex-column
                  justify-content-around
                  mt-0 mt-md-0
                "
              >
                <!-- .cont-title -->
                <div role="tablist">
                  <div class="row col-11">
                    <table class="tabla1">
                      <thead>
                        <tr>
                          <th class="td1">INFORMACIÓN:</th>
                          <th class="td2">
                            Radicado <b>{{ infoRPl.filing_number }}</b>
                          </th>
                          <th class="td2">
                            <span v-if="infoRPl.reception_date">
                              {{ infoRPl.reception_date.substring(0, 10) }}
                            </span>
                          </th>
                          <th class="td2">
                            {{ infoRPl.uploader.site.city.name }}
                          </th>
                        </tr>
                      </thead>
                    </table>
                  </div>
                  <div class="row">
                    <div class="col-12 mt-2">
                      <p class="p1">
                        <b>Selecciona cada etapa</b> para ver su documentación
                      </p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 div1 mt-3">
                      <img
                        v-show="stateProcess == 0"
                        src="@/assets/images/icons/bar1.svg"
                      />
                      <img
                        v-show="
                          stateProcess == 1 ||
                          stateProcess == 2 ||
                          stateProcess == 3 ||
                          stateProcess == 4
                        "
                        src="@/assets/images/icons/bar1Green.svg"
                      />

                      <a href="#" v-on:click="selectOptions(0)">
                        <img
                          v-show="stateProcess == 0"
                          src="@/assets/images/icons/circle1.svg"
                        />
                        <img
                          v-show="
                            stateProcess == 1 ||
                            stateProcess == 2 ||
                            stateProcess == 3 ||
                            stateProcess == 4
                          "
                          src="@/assets/images/icons/circle1Green.svg"
                        />
                        <img
                          v-show="stateProcess == 5"
                          src="@/assets/images/icons/circle1GreenBig.svg"
                        />
                      </a>

                      <img
                        v-show="stateProcess == 0"
                        src="@/assets/images/icons/grayBar.svg"
                      />
                      <img
                        v-show="stateProcess == 1 || stateProcess == 2"
                        src="@/assets/images/icons/orangeBar.svg"
                      />
                      <img
                        v-show="stateProcess == 3 || stateProcess == 4"
                        src="@/assets/images/icons/bar2Green.svg"
                      />

                      <a href="#" v-on:click="selectOptions(1)">
                        <img
                          v-show="stateProcess == 0"
                          src="@/assets/images/icons/circle2.svg"
                        />
                        <img
                          v-show="stateProcess == 1"
                          src="@/assets/images/icons/circleOrange2.svg"
                        />
                        <img
                          v-show="stateProcess == 2"
                          src="@/assets/images/icons/circleOrange2b.svg"
                        />
                        <img
                          v-show="stateProcess == 3 || stateProcess == 4"
                          src="@/assets/images/icons/circle2Green.svg"
                        />
                      </a>

                      <img
                        v-show="stateProcess == 0"
                        src="@/assets/images/icons/grayBar.svg"
                      />
                      <img
                        v-show="stateProcess == 1 || stateProcess == 2"
                        src="@/assets/images/icons/orangeBar.svg"
                      />
                      <img
                        v-show="stateProcess == 3 || stateProcess == 4"
                        src="@/assets/images/icons/bar2Green.svg"
                      />

                      <a href="#" v-on:click="selectOptions(2)">
                        <img
                          v-show="stateProcess == 0"
                          src="@/assets/images/icons/circle3.svg"
                        />
                        <img
                          v-show="stateProcess == 1"
                          src="@/assets/images/icons/circleOrange3.svg"
                        />
                        <img
                          v-show="stateProcess == 2"
                          src="@/assets/images/icons/circleOrange3b.svg"
                        />
                        <img
                          v-show="stateProcess == 3 || stateProcess == 4"
                          src="@/assets/images/icons/circleGreen3.svg"
                        />
                      </a>

                      <a href="#" v-on:click="selectOptions(3)">
                        <img
                          v-show="
                            stateProcess == 0 ||
                            stateProcess == 1 ||
                            stateProcess == 2
                          "
                          src="@/assets/images/icons/grayBar.svg"
                        />
                        <img
                          v-show="stateProcess == 3"
                          src="@/assets/images/icons/orangeBar.svg"
                        />
                        <img
                          v-show="stateProcess == 4"
                          src="@/assets/images/icons/bar2Green.svg"
                        />
                        <img
                          v-show="
                            stateProcess == 0 ||
                            stateProcess == 1 ||
                            stateProcess == 2
                          "
                          src="@/assets/images/icons/circle4.svg"
                          id="stagesOfWork"
                        />
                        <img
                          v-show="stateProcess == 3"
                          src="@/assets/images/icons/circleOrange4.svg"
                        />
                        <img
                          v-show="stateProcess == 4"
                          src="@/assets/images/icons/circle4green.svg"
                        />
                        <img
                          v-show="
                            stateProcess == 0 ||
                            stateProcess == 1 ||
                            stateProcess == 2
                          "
                          src="@/assets/images/icons/grayBarEnd.svg"
                        />
                        <img
                          v-show="stateProcess == 3"
                          src="@/assets/images/icons/orangeBarEnd.svg"
                        />
                        <img
                          v-show="stateProcess == 4"
                          src="@/assets/images/icons/greenBarEnd.svg"
                          id="stagesOfWork"
                        />
                      </a>
                      <img src="@/assets/images/icons/circleWhite.svg" />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-2 mt-0 pl-5 text-right">
                      <p class="p1">Recepción</p>
                    </div>
                    <div class="col-3 mt-0 pl-5 text-center">
                      <p class="p1">Solicitar información</p>
                    </div>
                    <div class="col-2 mt-0 mr-0 text-left">
                      <p class="p1">Respuesta</p>
                    </div>
                    <div class="col-2 mt-0 ml-3">
                      <p class="p1">Cierre</p>
                    </div>
                  </div>

                    <div class="row" v-if="linkProccess == 0">
                      <Reception :key="flagComponent" />
                    </div>
                    <div
                      class="row"
                      v-if="linkProccess == 1 && infoRPl.status != 'open'"
                    >
                      <RequestInfo :key="flagComponent" />
                    </div>
                    <div
                      class="row"
                      v-if="linkProccess == 2 && infoRPl.status != 'open'"
                    >
                      <Response :editorData="editorData" :key="flagComponent" />
                    </div>
                    <div
                      class="row"
                      v-if="
                        (linkProccess == 3 || linkProccess == 4) &&
                        infoRPl.status != 'open' &&
                        infoRPl.status != 'pending'
                      "
                    >
                      <Close :key="flagComponent" />
                    </div>

                  <small v-show="error.flag" class="alert-danger">{{
                    error.message
                  }}</small>
                  <b-popover show target="stagesOfWork" triggers="hover" placement="top">
                    <b> Quedan {{ infoRP.data.remaining_days }} días </b>
                  </b-popover>
                </div>
              </div>
              <div>
                <b-modal
                  ref="my-modal"
                  hide-footer
                  centered
                  title="Atención al mensaje:"
                  no-close-on-backdrop
                  @hidden="hideModal"
                >
                  <div class="d-block text-center">
                    <h3>{{ this.msjModal }}</h3>
                  </div>
                  <b-button
                    class="mt-3"
                    variant="outline-danger"
                    block
                    @click="hideModal"
                  >
                    Cerrar
                  </b-button>
                </b-modal>
              </div>
            </div>
            <a
              v-if="linkProccess < 2"
              class="col-12 col-md-6 col-lg-6 col-xl-6 d-flex align-items-center justify-content-center"
              style="height: 800px; background-color:#e5e5e5"
              :href="serverPath + '/' + infoRPl.file"
              target="blanck"
            >
              
                <p class="btn-pdf">Ver Derecho de Petición</p>
            <!-- <embed
                width="100%"
                height="100%"
                id="pdf-iframe"
                :src="serverPath + '/' + infoRPl.file"
              >
              <pdf :src="serverPath + '/' + infoRPl.file"></pdf> -->
            </a>
            <div
              v-show="linkProccess >= 2"
              class="col-12 col-md-6 col-lg-6 col-xl-6"
              style="height: 800px"
            >
              <div class="component-editor">
                <div class="form-group row">
                  <div :class="fieldDivClass">
                    <div class="document-editor__toolbar"></div>
                    <div class="document-editor__editable-container">
                      <div class="header">
                        <img :src="serverPath + '/' + headerLetter" alt="" />
                      </div>
                      <ckeditor
                        :editor="editor"
                        :config="editorConfig"
                        v-model="editorData"
                        @focus="setSignatureBP"
                        @ready="onReady"
                        :disabled="editorDisabled"
                      ></ckeditor>
                      <div class="footer">
                        <img :src="serverPath + '/' + footerLetter" alt="" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- .col -->
          </div>
          <!-- .row -->
        </div>
        <!-- .layout-content -->
      </div>
    </div>
  </div>
  <!-- #page-request -->
</template>

<script>
import MainBarMenu from "@/components/layouts/MainBarMenu.vue";
import HeadingUser from "@/components/user/HeadingUser.vue";
import { mapActions, mapState, mapMutations } from "vuex";
import serverConfig from "./../../services/config";
import Reception from "./reception";
import RequestInfo from "./requestInfo";
import Response from "./response";
import Close from "./close";
import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";

export default {
  name: "RightPetition",
  components: {
    MainBarMenu,
    HeadingUser,
    Reception,
    RequestInfo,
    Response,
    Close,
  },
  props: {
    fieldDivClass: {
      type: String,
      required: false,
      default: "col-md-12",
    },
  },
  data() {
    return {
      serverPath: serverConfig.permisosURL,
      error: {
        flag: false,
        class: "", //is-invalid
        message: "",
      },
      success: {
        flag: false,
        class: "", //is-valid
        message: "",
      },
      msjModal: "",
      flagPath: false,

      nameFile: "",
      show: true,
      flagComponent: 0,

      editor: DecoupledEditor,
      editorDisabled: false,
      editorData:"",
      editorConfig: {
        removePlugins: ["Link", "BlockQuote", "ImageUpload", "MediaEmbed"],
        placeholder:
          "Comienza a escribir aquí tu respuesta al Derecho de Petición…",
      },
    };
  },
  beforeMount() {
    this.actGetSocieties();
    this.setDraft(this.$route.params.id)
    this.actGetInfoRP(this.$route.params.id).then(() => {
      this.setInfoRPl(this.infoRP.data);
      let stateProcessTMP =
        this.infoRPl.status == "open"
          ? 0
          : this.infoRPl.status == "pending"
          ? 2
          : this.infoRPl.status == "closing"
          ? 3
          : 4;
      this.setLinkProccess(stateProcessTMP);
      this.setStateProcess(stateProcessTMP);
      this.setPreviusDraft();
      this.flagComponent += 1;
      let lastAnswer = this.infoRPl.answers.length - 1
      let answer = this.infoRPl.answers
        if (answer[lastAnswer].type == "final") {
          this.editorDisabled = true
          this.changeLinkOfSignature()
          this.societies.data.forEach((s) => {
            if (s.id == answer[lastAnswer].society_id) {
              this.setHeader(s.header_img);
              this.setFooter(s.footer_img);
            }
          });
        }
    });
  },
  computed: {
    ...mapState("modCore", ["user"]),
    ...mapState("modRequest", ["societies"]),
    ...mapState("modRightPetition", [
      "infoRP",
      "stateProcess",
      "infoRPl",
      "linkProccess",
      "headerLetter",
      "footerLetter",
      "bpSignature",
      "draft",
       "loading"
    ]),

    // diffDate: function () {
    //   if (this.infoRPl.reception_date) {
    //     let currentDay = new Date();
    //     let fechaInitial = new Date(this.infoRPl.reception_date);
    //     fechaInitial.setDate(fechaInitial.getDate() + 15);
    //     if (fechaInitial.getTime() <= currentDay.getTime()) {
    //       return 0;
    //     } else {
    //       var timeDiff = Math.abs(
    //         fechaInitial.getTime() - currentDay.getTime()
    //       );
    //       return Math.ceil(timeDiff / (1000 * 3600 * 24));
    //     }
    //   } else {
    //     return "";
    //   }
    // },
  },
  methods: {
    ...mapActions("modRightPetition", ["actGetInfoRP","actSetSignatureBP","setDraft"]),
    ...mapActions("modRequest", ["actGetSocieties"]),
    ...mapMutations("modRightPetition", [
      "setStateProcess",
      "setInfoRPl",
      "setLinkProccess",
      "setHeader",
      "setFooter"
    ]),
    setPreviusDraft(){
      this.editorData = ''
      if(this.draft !== ""){
        this.editorData = this.draft
      }else if(this.draft === null){
        this.editorData = ''
      }
    },
    changeLinkOfSignature(){
      let message = ""
      let lastAnswer = this.infoRPl.answers.length - 1
      let answer = this.infoRPl.answers
      let array = answer[lastAnswer].letter.split('"')
      for (var i = 0; i < array.length; i++){
          if(array[i].includes("firmaPdf.")){
            if(this.infoRPl.business_partner_id !== null){
              array[i] = `${this.serverPath + this.bpSignature.signature}`
            }else if (this.infoRPl.business_partner_id == null){
              array[i] = `${this.serverPath + this.user.signature}`
            }
        }
      }
        for (var x = 0; x < array.length; x++){
         message += (array[x] + '"')
        }
      if(message.endsWith('""')){
        message = message.substr(0, message.lastIndexOf('""'))
      }else{
        message = message.substr(0, message.lastIndexOf('"'))
      }
      this.editorData = message
    },
    setSignatureBP(){
      let signature = `
      <br><br><br>
       <div class="row mb-0">    
                 <figure class="image ck-widget image-style-align-left" style="width:50px;">
                   <img width="250px" align="left" style="width:250px;height:100px;"
                   src="${this.serverPath + this.bpSignature.signature}"
                   >
                 </figure>
                  <br><br><br>
                   <p class="p3">${this.bpSignature.name}</p>
                   <p class="p3">Business Partner</p>                        
        </div>
       `
       let signature2 = `
      <br><br><br>
       <div class="row mb-0">    
                 <figure class="image ck-widget image-style-align-left" style="width:50px;">
                   <img width="250px" align="left" 
                   src="${this.serverPath + this.user.signature}"
                   >
                 </figure>
                    <br><br><br>
                   <p class="p3">${this.user.name}</p>
                   <p class="p3">Business Partner</p>                       
        </div>
       `
      if(this.editorData === '' && this.infoRPl.business_partner_id !== null){
        this.editorData += signature 
      }else if (this.editorData === '' && this.infoRPl.business_partner_id == null){
        this.editorData += signature2 
      }

    },
    onReady(editor) {
      const toolbarContainer = document.querySelector(
        ".document-editor__toolbar"
      );
      toolbarContainer.appendChild(editor.ui.view.toolbar.element);
      //console.log(Array.from( editor.ui.componentFactory.names()));
    },

    selectOptions(id) {
      this.setLinkProccess(id);
      if (id == 1 && this.infoRPl.status == "pending") {
        this.setStateProcess(1);
      }
      if (id == 2 && this.infoRPl.status == "pending") {
        this.setStateProcess(2);
      }
      this.flagComponent += 1;
    },

    formatDateShow(date) {
      var d = new Date(date);
      var datestring =
        d.getDate() +
        " " +
        this.monthNames[d.getMonth() + 1] +
        " " +
        d.getFullYear();
      return datestring;
    },

    fileSelected() {
      const dato = document.querySelector("#fileDocu");
      this.nameFile = dato.files[0].name;
      //alert(this.header_img)
    },

    showModal(msj, flag) {
      this.msjModal = msj;
      this.flagPath = flag;
      this.$refs["my-modal"].show();
    },
    hideModal() {
      this.$refs["my-modal"].hide();
      if (this.flagPath == 1) {
        this.$router.push({ path: "/solicitudes" });
      }
    },
  },
};
</script>

<style lang="scss">
//@import url('https://fonts.googleapis.com/css2?family=Open+Sans&display=swap');
.page-rightpetition {
  .ck-content .image img {
    max-width: 250px;
    }
  .title-1 {
    font-size: 24px;
    font-weight: bold;
    color: #1c3a4e;
  }
  .cont-rightpetition-text {
    .cont-title {
      color: #1c3a4e;
      .title-1 {
        font-size: 20px;
        font-weight: bold;
        color: #1c3a4e;
      }
      .title-2 {
        font-weight: bold;
        font-size: 25px;
        line-height: 27px;

        @media (min-width: 768px) {
          font-size: 80px;
          line-height: 80px;
        }
      }
    }
    .form-rightpetition {
      .form-group-req {
        input[type="text"] {
          height: 32px;
          border: 1px solid #454545;
          border-radius: 4px;
          padding: 0 10px;
        }
      }
    }
  }
  .btn-pdf{
    color: gray;
    font-size: 24px;
    font-weight: 500;
  }
  .button1 {
    background: #e9ecee;
    font-family: "Open Sans";
    color: #1c3a4e;
    //border-radius: 50px;
    height: 25px;
    font-size: 16px;
    text-align: left !important;
    padding-left: 5%;
    padding-right: 5%;
  }
  .button2 {
    background: #1c3a4e;
    color: #ffffff;
    border-radius: 50px;
    height: 32px;
    font-size: 16px;
    text-align: left !important;
    padding-left: 5%;
    padding-right: 5%;
    &:hover {
      background: darken(#cddce6, 5);
    }
  }
  .button3 {
    border: none;
    background-color: inherit;
    padding: 5px 10px;
    font-size: 11px;
    cursor: pointer;
    display: inline-block;
    text-decoration: underline;
  }
  .button4 {
    background: #99a6af;
    color: #ffffff;
    border-radius: 8px;
    height: 32px;
    font-size: 16px;
    text-align: left !important;
    padding-left: 5%;
    padding-right: 5%;
    &:hover {
      background: darken(#99a6af, 5);
    }
  }
  .button2:hover {
    background: #eee;
  }
  .default {
    color: black;
  }
  .tr1 {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    color: #454545;
    padding-left: 5%;
  }
  .td1 {
    background: #1c3a4e;
    color: #ffffff;
    font-family: "Open Sans";
    font-weight: bold;
    font-size: 12px;
    line-height: 19px;
    padding-left: 1%;
    padding-right: 1%;
    width: 100px;
  }
  .td2 {
    background: #ffffff;
    color: #1c3a4e;
    font-family: "Open Sans";
    font-weight: normal;
    font-style: normal;
    font-size: 13px;
    line-height: 19px;
    width: 95px;
    text-align: center;
  }
  .td3 {
    background: #ffffff;
    color: #303030;
    font-family: "Open Sans";
    font-weight: normal;
    font-style: normal;
    font-size: 12px;
    line-height: 25px;
    text-align: center;
  }
  .td4 {
    background: #ffffff;
    color: #303030;
    font-family: "Open Sans";
    font-weight: normal;
    font-style: normal;
    font-size: 10px;
    line-height: 12px;
    text-align: center;
  }
  .td5 {
    background: #ffffff;
    color: #303030;
    font-family: "Open Sans";
    font-weight: normal;
    font-style: normal;
    font-size: 12px;
    line-height: 12px;
  }
  .tabla1 {
    border-radius: 5px;
    border: 3px solid #1c3a4e;
    border-color: #1c3a4e;
    -moz-border-radius: 6px;
    border-collapse: separate;
    border-spacing: 0px;
    width: 470px;
  }
  .p1 {
    color: #1c3a4e;
    font-family: "Open Sans";
    font-weight: normal;
    font-style: normal;
    font-size: 13px;
    line-height: 19px;
  }
  .div1 {
    height: 70px;
  }

  .collapsed > .when-opened,
  :not(.collapsed) > .when-closed {
    display: none;
  }
  .img1 {
    width: 18px;
    height: 18px;
    left: 100%;
    top: 100%;
    float: center;
  }
  .centerImg1 {
    width: 16px;
    height: 16px;
    top: 100%;
    float: right;
  }
  .mycheck {
    vertical-align: middle;
    position: relative;
    bottom: 1px;
  }
  /* The switch - the box around the slider */
  .switch {
    position: relative;
    display: inline-block;
    width: 45px;
    height: 19px;
  }

  /* Hide default HTML checkbox */
  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  /* The slider */
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 12px;
    width: 12px;
    left: 4px;
    bottom: 4px;
    background-color: #242424;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  input:checked + .slider {
    background-color: #779b49;
  }

  input:focus + .slider {
    box-shadow: 0 0 1px #779b49;
  }

  input:checked + .slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
  }

  /* Rounded sliders */
  .slider.round {
    border-radius: 34px;
  }

  .slider.round:before {
    border-radius: 50%;
  }
  .custom-file-upload {
    border: 1px solid #ccc;
    display: inline-block;
    padding: 1px 2px;
    cursor: pointer;
  }
  input[type="file"] {
    display: none;
  }
  .scrollable {
    overflow: hidden;
    overflow-y: scroll;
    height: calc(30vh - 20px);
  }

  .file-upload-img {
    width: 120px;
    height: 80px;
    //border-style: dotted;
    text-align: center;
    display: flex;
    align-items: center;
  }
  .file-upload-img img {
    width: 60px;
    height: 60px;
    align-items: center;
  }
  input[type="file"] {
    opacity: 0;
    filter: alpha(opacity=0);
    display: block;
    width: 150px;
    height: 120px;
    position: absolute;
    cursor: pointer;
  }

  .switch {
    position: relative;
    display: inline-block;
    width: 45px;
    height: 19px;
  }

  /* Hide default HTML checkbox */
  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .header img {
    width: 100%;
    border: 1px hsl(0, 0%, 82.7%) solid;
  }

  .footer img {
    width: 100%;
    border: 1px hsl(0, 0%, 82.7%) solid;
  }
  .document-editor {
    border: 1px solid var(--ck-color-base-border);
    border-radius: var(--ck-border-radius);

    /* Set vertical boundaries for the document editor. */
    max-height: 700px;

    /* This element is a flex container for easier rendering. */
    display: flex;
    flex-flow: column nowrap;
  }

  .document-editor__toolbar {
    /* Make sure the toolbar container is always above the editable. */
    z-index: 1;

    /* Create the illusion of the toolbar floating over the editable. */
    box-shadow: 0 0 5px hsla(0, 0%, 0%, 0.2);

    /* Use the CKEditor CSS variables to keep the UI consistent. */
    border-bottom: 1px solid var(--ck-color-toolbar-border);
  }

  /* Adjust the look of the toolbar inside the container. */
  .document-editor__toolbar .ck-toolbar {
    border: 0;
    border-radius: 0;
  }

  /* Make the editable container look like the inside of a native word processor application. */
  .document-editor__editable-container {
    padding: calc(2 * var(--ck-spacing-large));
    background: var(--ck-color-base-foreground);

    /* Make it possible to scroll the "page" of the edited content. */
    overflow-y: scroll;
  }

  .document-editor__editable-container .ck-editor__editable {
    /* Set the dimensions of the "page". */
    /* width: 15.8cm;
    min-height: 21cm; */

    /*height: 29.7cm;
  min-height: 29.7cm; */
    width: 100%;
    height: 21cm;
    min-height: 21cm;

    /* Keep the "page" off the boundaries of the container. */
    padding: 0cm 10%;

    border: 1px hsl(0, 0%, 82.7%) solid;
    border-radius: var(--ck-border-radius);
    background: white;

    /* The "page" should cast a slight shadow (3D illusion). */
    box-shadow: 0 0 5px hsla(0, 0%, 0%, 0.1);

    /* Center the "page". */
    margin: 0 auto;
  }

  /* Set the default font for the "page" of the content. */
  .document-editor .ck-content,
  .document-editor .ck-heading-dropdown .ck-list .ck-button__label {
    font: 16px/1.6 "Helvetica Neue", Helvetica, Arial, sans-serif;
  }

  /* Adjust the headings dropdown to host some larger heading styles. */
  .document-editor .ck-heading-dropdown .ck-list .ck-button__label {
    line-height: calc(
      1.7 * var(--ck-line-height-base) * var(--ck-font-size-base)
    );
    min-width: 6em;
  }

  /* Scale down all heading previews because they are way too big to be presented in the UI.
  Preserve the relative scale, though. */
  .document-editor
    .ck-heading-dropdown
    .ck-list
    .ck-button:not(.ck-heading_paragraph)
    .ck-button__label {
    transform: scale(0.8);
    transform-origin: left;
  }

  /* Set the styles for "Heading 1". */
  .document-editor .ck-content h2,
  .document-editor .ck-heading-dropdown .ck-heading_heading1 .ck-button__label {
    font-size: 2.18em;
    font-weight: normal;
  }

  .document-editor .ck-content h2 {
    line-height: 1.37em;
    padding-top: 0.342em;
    margin-bottom: 0.142em;
  }

  /* Set the styles for "Heading 2". */
  .document-editor .ck-content h3,
  .document-editor .ck-heading-dropdown .ck-heading_heading2 .ck-button__label {
    font-size: 1.75em;
    font-weight: normal;
    color: hsl(203, 100%, 50%);
  }

  .document-editor
    .ck-heading-dropdown
    .ck-heading_heading2.ck-on
    .ck-button__label {
    color: var(--ck-color-list-button-on-text);
  }

  /* Set the styles for "Heading 2". */
  .document-editor .ck-content h3 {
    line-height: 1.86em;
    padding-top: 0.171em;
    margin-bottom: 0.357em;
  }

  /* Set the styles for "Heading 3". */
  .document-editor .ck-content h4,
  .document-editor .ck-heading-dropdown .ck-heading_heading3 .ck-button__label {
    font-size: 1.31em;
    font-weight: bold;
  }

  .document-editor .ck-content h4 {
    line-height: 1.24em;
    padding-top: 0.286em;
    margin-bottom: 0.952em;
  }

  /* Set the styles for "Paragraph". */
  .document-editor .ck-content p {
    font-size: 1em;
    line-height: 1.63em;
    padding-top: 0.5em;
    margin-bottom: 1.13em;
  }

  /* Make the block quoted text serif with some additional spacing. */
  .document-editor .ck-content blockquote {
    font-family: Georgia, serif;
    margin-left: calc(2 * var(--ck-spacing-large));
    margin-right: calc(2 * var(--ck-spacing-large));
  }

  #loader {
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 1;
    width: 150px;
    height: 150px;
    margin: 85px 0 0 -75px;
    border: 16px solid #f3f3f3;
    border-radius: 50%;
    border-top: 16px solid #3498db;
    width: 120px;
    height: 120px;
    -webkit-animation: spin 2s linear infinite;
    animation: spin 2s linear infinite;
  }

  @-webkit-keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
    }
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  /* Small devices (landscape phones, 576px and up) */
  @media (min-width: 576px) {
  }

  /* Medium devices (tablets, 768px and up) */
  @media (min-width: 768px) {
  }

  /* Large devices (desktops, 992px and up) */
  @media (min-width: 992px) {
  }

  /* Extra large devices (large desktops, 1200px and up)*/
  @media (min-width: 1200px) {
  }
}
</style>